module.exports = __webpack_public_path__ + "img/back-button.a0114655.svg";